import React, { useState, useEffect } from "react";
import "./VariableCostScreen.css";
import Button from "../../components/Button/Button";
import Header from "../../components/Header/Header";
import TextInput from "../../components/TextInput/TextInput";
import Navbar from "../../components/Navbar/Navbar";

/**Firebase Imports**/
import {
	auth,
	db,
	collection,
	setDoc,
	getDoc,
	doc,
} from "../../firebaseConfig";
import { showError } from "../../helpers/showError";
import DynamicTextInput from "../../components/DynamicTextInput/DynamicTextInput";
import BackDrop from "../../components/BackDrop/BackDrop";
import AddInputForm from "./AddInputForm/AddInputForm";

const VariableCostScreen = () => {
	const costsRef = collection(db, "variable_costs");

	const [costPerGallon, setCostPerGallon] = useState(0);
	const [milePerGallon, setMilePerGallon] = useState(0);

	const [showAddInput, setShowAddInput] = useState(false);
	const [checkErrors, setcheckErrors] = useState(false);
	const [isProcessing, setIsProcessing] = useState(false);

	const [milesInputs, setMilesInputs] = useState([]);
	const [weekInputs, setWeekInputs] = useState([]);

	const [fuelCostPerMile, setFuelCostPerMile] = useState(0); //Fuel Cost Per Mile Result
	const [costPerMile, setCostPerMile] = useState(0); //Cost Per Mile Result
	const [weekBasedCost, setWeekBasedCost] = useState(0); //Total Monthly Fixed Cost Result

	/**
	 * Main Functions
	 * **/

	const handleUpdate = async () => {
		setIsProcessing(true);
		setcheckErrors(true);
		var milesErrors = milesInputs.find((x) => x.value === "");
		var weekErrors = weekInputs.find((x) => x.value === "");
		var cpgError = costPerGallon === "";
		var mpgError = milePerGallon === "";

		if (milesErrors || weekErrors || cpgError || mpgError) {
			setIsProcessing(false);
			return;
		}

		await setDoc(doc(costsRef, auth.currentUser.uid), {
			milesInputs: milesInputs,
			weekInputs: weekInputs,
			costPerGallon: costPerGallon,
			milePerGallon: milePerGallon,
		})
			.then(() => {
				//costs updated
				alert("Costs updated successfully");
				setIsProcessing(false);
			})
			.catch((error) => {
				showError(error);
				setIsProcessing(false);
			});
	};

	useEffect(() => {
		const getInputs = async () => {
			const docSnap = await getDoc(
				doc(db, "variable_costs", auth.currentUser.uid)
			);
			if (docSnap.exists()) {
				const milesInputsTemp = docSnap.data().milesInputs;
				const weekInputsTemp = docSnap.data().weekInputs;
				const cpgTemp = docSnap.data().costPerGallon;
				const mpgTemp = docSnap.data().milePerGallon;
				if (milesInputsTemp !== undefined && weekInputsTemp !== undefined) {
					setMilesInputs(milesInputsTemp);
					setWeekInputs(weekInputsTemp);
				} else {
					setMilesInputs([{ name: "Maintenance", value: "" }]);
					setWeekInputs([{ name: "Miscellaneous", value: "" }]);
				}
				if (cpgTemp !== undefined && mpgTemp !== undefined) {
					setCostPerGallon(cpgTemp);
					setMilePerGallon(mpgTemp);
				}
			} else {
				setMilesInputs([{ name: "Maintenance", value: "" }]);
				setWeekInputs([{ name: "Miscellaneous", value: "" }]);
			}
		};
		getInputs();
		return () => console.log("");
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [auth.currentUser]);

	// update fuel cost Result
	const updateFuelCostResult = () => {
		setFuelCostPerMile(
			costPerGallon / (milePerGallon === 0 ? 1 : milePerGallon)
		);
	};
	useEffect(() => {
		updateFuelCostResult();
		return () => "";
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [costPerGallon, milePerGallon]);

	// update Result
	const updateResult = () => {
		setCostPerMile(
			milesInputs.reduce((x, a) => x + parseFloat(a.value), 0) + fuelCostPerMile
		);
		setWeekBasedCost(weekInputs.reduce((x, a) => x + parseFloat(a.value), 0));
		console.log("Result Updated");
	};
	useEffect(() => {
		updateResult();
		return () => "";
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [milesInputs, weekInputs, fuelCostPerMile]);
	/** **/

	return (
		<div className="VariableCostScreen h-full w-full overflow-y-auto m-0 p-3 py-8">
			<div className="h-full w-full m-0 p-0">
				{showAddInput && (
					<>
						<BackDrop onClick={() => setShowAddInput(false)} />
						<AddInputForm
							array={showAddInput}
							milesInputs={milesInputs}
							weekInputs={weekInputs}
							setMilesInputs={setMilesInputs}
							setWeekInputs={setWeekInputs}
							setShowAddInput={setShowAddInput}
						/>
					</>
				)}

				<Navbar backTarget={"/landing"} />

				<Header className={"mt-8"} size={"medium"}>
					VARIABLE COST
				</Header>

				<div className="flex flex-col mx-auto" style={{ maxWidth: 550 }}>
					<Header className={"my-5"} size={"small"}>
						Variable Costs For The Week
					</Header>

					<Header className={"mt-6"} size={"extra-small"}>
						Cost Based On Miles
					</Header>

					{/*-------------*/}
					<div className="flex items-center justify-between border-2 border-black h-16 my-3 mr-2 p-2">
						<p className="cost">Fuel</p>
						<div className="flex flex-col items-center">
							<small className="">Cost Per Gallon</small>
							<TextInput
								className={"shadow-none small-inputs text-center"}
								type={"number"}
								name={"costPerGallon"}
								id={"costPerGallon"}
								value={costPerGallon}
								onChange={(e) => {
									setCostPerGallon(e.target.value);
								}}
								error={costPerGallon === ""}
								errorMessage={<small>*invalid input</small>}
							/>
						</div>

						<div className="flex flex-col items-center">
							<small className="">MPG</small>
							<TextInput
								className={"shadow-none small-inputs text-center"}
								type={"number"}
								name={"milePerGallon"}
								id={"milePerGallon"}
								value={milePerGallon}
								onChange={(e) => {
									setMilePerGallon(e.target.value);
								}}
								error={milePerGallon === ""}
								errorMessage={<small>*invalid input</small>}
							/>
						</div>

						<div className="flex flex-col items-center">
							<small className="">Fuel Cost Per Mile</small>
							<p className="cost result mt-1">${fuelCostPerMile.toFixed(2)}</p>
						</div>
					</div>

					{/*-------------*/}
					<div className="costBasedOnMiles text-start pr-14 items-center flex flex-col">
						<Button
							mode={"filled"}
							title={"ADD+"}
							size={"xs"}
							className={"my-3 mr-auto"}
							onClick={() => {
								setShowAddInput(1);
							}}
						/>

						{
							// dynamic miles inputs
							milesInputs.map(({ name, value }, index) => (
								<DynamicTextInput
									key={index}
									id={index}
									value={value}
									array={milesInputs}
									name={name}
									type={"number"}
									placeholder={name}
									className={"my-2 shadow-none"}
									checkErrors={checkErrors}
									updateResult={updateResult}
								/>
							))
						}

						<div className="calculations my-8 mr-auto">
							<p className="cost my-2">
								Total Var. Cost Per Mile:{" "}
								<span className="result">${costPerMile.toFixed(2)}</span>
							</p>
						</div>
					</div>

					{/*-------------*/}
					<div className="costBasedOnMiles text-start pr-14 items-center flex flex-col">
						<Header className={"mt-10 mr-auto"} size={"extra-small"}>
							Cost Based On The Week
						</Header>

						<Button
							mode={"filled"}
							title={"ADD+"}
							size={"xs"}
							className={"my-3 mr-auto"}
							onClick={() => {
								setShowAddInput(2);
							}}
						/>

						{
							// dynamic week inputs
							weekInputs.map(({ name, value }, index) => (
								<DynamicTextInput
									key={index}
									id={index}
									value={value}
									array={weekInputs}
									name={name}
									type={"number"}
									placeholder={name}
									className={"my-2 shadow-none"}
									checkErrors={checkErrors}
									updateResult={updateResult}
								/>
							))
						}

						<div className="calculations my-8 mr-auto">
							<p className="cost my-2">
								Total Weekly Based Cost:{" "}
								<span className="result">${weekBasedCost.toFixed(2)}</span>
							</p>
						</div>
					</div>

					<Button
						mode={"filled"}
						size={"lg"}
						title={isProcessing ? "o o o" : "UPDATE"}
						disabled={isProcessing}
						className={"my-6 mx-auto"}
						onClick={() => handleUpdate()}
					/>
				</div>
			</div>
		</div>
	);
};

export default VariableCostScreen;
